
import { mdiInformationOutline, mdiMessageText } from "@mdi/js"
import Button from "@/components/base/Button"
export default {
    name: "BusinessReplySuggestion",
    components: { Button },
    props: {
        message: {
            type: Object,
        },
    },
    data: () => ({
        mdiInformationOutline,
        mdiMessageText,
        accepted: false,
    }),
    methods: {
        setMessage() {
            this.$oabalytics.trackEvent("business-suggestion_copy")
            this.accepted = true
            const username = this.message.data.name
            const cp = this.$auth.user.business.public_contact_person
            let displayName
            if (cp) {
                displayName = `${cp.firstname} ${cp.lastname}`
            }
            this.$root.$emit(
                "setChatInput",
                `Hallo ${username},

hast du Lust unsere Berufe in einem Praktikum auszuprobieren?
Oder möchtest du mal einen Tag vorbeikommen?

Viele Grüße${displayName ? "\n" + displayName : ""}`
            )
        },
    },
}
